import { render } from "./ModuleFacets.vue?vue&type=template&id=f986158a"
import script from "./ModuleFacets.vue?vue&type=script&lang=js"
export * from "./ModuleFacets.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__